import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
//| import { Theme } from '@mui/material/styles';
import { makeStyles, useTheme ,} from '@mui/styles';
import { createStyles } from '@mui/styles';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import { useState, useEffect } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import PasswordField from '../../components/PasswordField/PasswordField';
import { ScreenTitle } from '../../components/ScreenTitle';
import { FormTextField } from '../../components/forms/FormTextField';
import schemas from '../../data/schemas';
import { login } from '../../store/action_creators/auth.actions';
import { clearAuthError } from '../../store/action_creators/auth.actions';
import { AppActions } from '../../store/config/ActionTypes';
import { RootState, UserCredentials } from '../../store/config/types';
import variables from '../../styles/_variables.module.scss';
import { CustomSnackbar } from './../../components/CustomSnackbar';
import { Status } from './../../store/config/enums';
import { Theme } from '@mui/material';
import { Console } from 'console';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      margin: '1.75rem 0',
    },
    registerText: {
      textAlign: 'center',
      fontWeight: 400,
    },
    link: {
      color: variables.primary,
      fontWeight: 400,
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'underline',
        color: variables.primaryMidtone,
      },
    },
    passwordField: {
      position: 'relative',
    },
  }),
);

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, AppActions>) => ({
  login: (user: UserCredentials) => dispatch(login(user)),
  clearAuthError: () => dispatch(clearAuthError()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Values {
  otp: string;
  email: string;
  password: string;
}

function Login({ auth, login, clearAuthError }: PropsFromRedux) {
   
  const [loggingIn, setLoggingIn] = useState<boolean>(false);
  const [hasRedirected, setHasRedirected] = useState<boolean>(false);
  const classes = useStyles(useTheme());
  const navigate = useNavigate();


  const submitLogin = (values: Values, helpers: FormikHelpers<Values>) => {
    const user: UserCredentials = {
      email: values.email,
      password: values.password,
      otp: values.otp,
    };

    setLoggingIn(true);
    login(user);

  };

  const closeSnack = () => {
    setLoggingIn(false);
  };

  // If the auth state changes (error, challenge or success), stop the local "loggingIn" spinner
  useEffect(() => {
    if (auth.logInErrorMessage || auth.twoFactorChallenge || auth.loggedIn) {
      setLoggingIn(false);
    }
  }, [auth.logInErrorMessage, auth.twoFactorChallenge, auth.loggedIn]);

  // Reset redirection flag when errorCode changes
  useEffect(() => {
    if (auth.errorCode !== 300) {
      setHasRedirected(false);
    }
  }, [auth.errorCode]);

  // Redirect to register step 2 when errorCode is 300
  useEffect(() => {
    if (auth.errorCode === 300 && !hasRedirected) {
      setHasRedirected(true);
      clearAuthError(); // Clear first to prevent loops
      navigate('/register?step=2');
    }
  }, [auth.errorCode, navigate, clearAuthError, hasRedirected]);

  return (
    <div className="screen-container profile" >
      <Paper elevation={2}>
        <ScreenTitle title="Iniciar sesión" />
        <Formik
          initialValues={{ email: '', password: '' ,otp: '' }}
          validationSchema={schemas.LoginSchema}
          onSubmit={submitLogin}
        >
          {({ values, errors }) => (
            <Form className="form">
              <Field
                className="form-row"
                name="email"
                component={FormTextField}
                type="text"
                placeholder="Correo electrónico"
                value={values['email']}
              />
              <PasswordField inputName="password" />
   
                <Field
                  className="form-row"
                  name="otp"
                  component={FormTextField}
                  type="text"
                  placeholder="Código 2FA"
                  value={values['otp']}
                />
            
           
                  <Button type="submit" color="primary" variant="contained" disabled={loggingIn}>
                  {loggingIn ? <CircularProgress size={28} color="inherit" /> : 'Ingresar'}
                </Button>
                   <div>
        {auth.twoFactorChallenge && (
          (() => {
            try {
              const parsed = JSON.parse(auth.twoFactorChallenge as string);
              // accept both PascalCase (QrCode/ManualCode) and camelCase (qrCode/manualCode) keys
              const qr = parsed.QrCode || parsed.qrCode || parsed.qr || parsed.QR || null;
              const manual = parsed.ManualCode || parsed.manualCode || parsed.manual || null;

              if (parsed && (qr || manual)) {
                return (
                  <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                    {qr && (
                      <>
                        <p>Escanea este código QR con tu aplicación de autenticación:</p>
                        <img
                          src={qr}
                          alt="Código QR"
                          style={{ width: '200px', height: '200px' }}
                        />
                      </>
                    )}
                    {manual && (
                      <>
                        <p>O usa este código manual:</p>
                        <strong>{manual}</strong>
                      </>
                    )}
                  </div>
                );
              }
            } catch (e) {
              // no es JSON: mostramos el string bruto
              return <div style={{ color: variables.plexoRed, marginTop: '1rem' }}>{auth.twoFactorChallenge}</div>;
            }
            return null;
          })()
        )}         </div>
            </Form>
          )}
      
        </Formik>
       
        <Divider className={`${classes.divider} divider`} />
        <div className="sign-in-toggle">
          <Typography className={classes.registerText} variant="subtitle2">
            ¿Aún no tienes una cuenta?
          </Typography>
          <Link to="/register">Regístrate aquí</Link>
        </div>
        <CustomSnackbar
          // Do not show snackbar when there's a twoFactorChallenge (we show the QR instead)
          open={auth.logInErrorMessage !== null && !auth.twoFactorChallenge}
          message={auth.logInErrorMessage || ''}
          handleClose={closeSnack}
          type={Status.ERROR}
        />
        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <Link to="/reset-password" className={classes.link}>
            Reiniciar contraseña
          </Link>
        </div>
      </Paper>
    </div>
  );
}

export default connector(Login);
